<script>
  import {VueMaskDirective as mask} from 'v-mask'

  export default {
    nome: 'lista grvs',
    directives: {mask},
    data () {
      return {
        isLoading: false
      }
    },
    computed: {},
    mounted () {
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Selecione Pré-Retirada para modificar</span>
                  </h1>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">
                    <router-link class="btn btn-default btn-sm m-l-xs" :to="{name: 'addpreretirada.visualizar'}">Adicionar Pré-Retirada </router-link>
                    <router-link class="btn btn-default btn-sm m-l-xs" :to="{name: 'externa.visualizar'}">Adicionar Cobrança Externa </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-12 m-b-xs ">
                  <div class="row">
                    <div class="col-sm-6 pull-right m-r-xs">
                      <div class="input-group">
                        <input type="text" class="input-md form-control" placeholder="Pesquisar">
                        <span class="input-group-btn">
                          <button class="btn btn-md btn-default" type="button" style="height: 34px;">Buscar</button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="hidden-print">
                <div class="panel wrapper-lg m-t-n" v-show="showFiltros">
                  <div class="r-table-content_ m-t-n">
                    <div class="row">
                      <div class="col-sm-6">

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="text-xs font-thin text-light m-l-lg">Duplo clique para abrir o arrematante </div>
              <div class="table-responsive">
                <table class="table table-hover table-bordered table-striped b-t b-light" style="border-top: 1px solid #eaeff0;">
                  <thead>
                    <tr>
                      <th style="width:20px;">
                        <label class="i-checks m-b-none">
                          <input type="checkbox" @change="checkAll(data)" v-model="checkedAll" tabindex="0" aria-checked="false" aria-invalid="false"><i></i>
                        </label>
                      </th>
                      <th>GRV</th>
                      <th>Responsável para pagamento</th>
                      <th>Pátio</th>
                      <th>Data prevista para retirada</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="v-middle">
                        <label class="i-checks m-b-none">
                          <input type="checkbox" name="post[]" tabindex="0" aria-checked="false" aria-invalid="false"><i></i>
                        </label>
                      </td>
                      <td scope="row">
                        <router-link class="text-info" :to="{name: 'pre-retirada.visualizar'}">820000602</router-link>
                      </td>
                      <td scope="row">Luiz Thomaz Fernandes</td>
                      <td scope="row">Campo Grande</td>
                      <td scope="row">22/11/2019</td>
                    </tr>

                    <!--<tr v-if="!filteredData || filteredData.length === 0">
                      <td colspan="6">Nenhum registro encontrado</td>
                    </tr>-->
                  </tbody>
                </table>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// ListaRetirada.vue?1499926a